import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

// Initialize React Plugin
export const reactPlugin = new ReactPlugin();

// Configuration from environment variables (CRA format)
const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
const isDev = process.env.NODE_ENV === 'development';

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    extensions: [reactPlugin],
    // Désactivé (décision S-D7, 2026-10-26) : TelemetryTracker envoie déjà une page vue à
    // chaque changement de route, après la mise à jour du titre. Les deux ensemble
    // comptaient presque chaque navigation deux fois (docs/seo/, § 2.5).
    enableAutoRouteTracking: false,
    disableTelemetry: isDev, // Disable in development to avoid clutter and save quota
    // @ts-ignore - Property exists in JS but might be missing from some TS type definitions
    disableStorageSync: true, // Fix net::ERR_NAME_NOT_RESOLVED for ai.config.1.cfg.json
  },
});

if (connectionString) {
  try {
    appInsights.loadAppInsights();
    console.log('[Telemetry] Application Insights initialized');
  } catch (error) {
    console.error('[Telemetry] Application Insights initialization failed:', error);
  }
} else if (!isDev) {
  console.warn('[Telemetry] REACT_APP_APPINSIGHTS_CONNECTION_STRING is not defined. Telemetry disabled.');
}

export default appInsights;
